<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(`commands.form.${config.name}.label`) }}
      </label>
      <v-select
        v-if="!loading"
        v-model="model"
        :options="itemsOptions"
        :clearable="true"
        :reduce="(val) => val.value"
        input-id="device_proxy_id"
        :multiple="multiple"
        @input="$emit('input', model)"
      />
      <p v-else>Loading...</p>
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import axios from "@/libs/axios";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      items: [],
      options: [],
      fromAlarm: false,
      showFromAlarm: false,
      loading: true,
    };
  },
  created() {
    this.showFromAlarm = this.context.flowchartConfig.alarm_compatible;
    this.model = this.value || null;
    this.fromAlarm = this.showFromAlarm && this.value === "from_alarm";
  },
  async mounted() {
    await this.$nextTick();
    await this.fetchDevices(this.context.model.device_type);
  },
  watch: {
    fromAlarm: {
      // handler(value) {
      //   if (value) {
      //     this.$emit("input", "from_alarm");
      //     this.model = null;
      //   } else {
      //     this.$emit("input", null);
      //   }
      // },
    },
  },
  computed: {
    itemsOptions() {
      if (this.options.length) {
        return this.options;
      }

      this.options = [...this.items];

      return this.options;
    },
  },
  methods: {
    async fetchDevices(deviceType) {
      this.items = [];

      // if (!facilityId || facilityId === 'from_alarm') {
      //   this.loading = false;
      //   return;
      // }

      this.loading = true;

      const deviceTypeClass = {
        generic_device: ''
      };

      const {data} = await axios.get(`/v1/proxy_camera?device_type=${deviceType}`);
      console.log(data)
      this.items = data.data.map((item) => ({
        value: item.id,
        label: item.camera.name,
      }));

      this.loading = false;
    },
  }
};
</script>

<style></style>
